<template>
  <div class="br-subleft overflow-y-auto" style="z-index: 1" :data-min="status">
    <div>
      <h6
        v-show="!isHistoryData"
        class="
          tx-uppercase tx-12 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("order.订单状态") }}
      </h6>
      <nav
        class="mg-b-30 nav br-nav-mailbox flex-column"
        v-show="!isHistoryData"
      >
        <template v-for="item in m_status">
          <div
            class="group-name-wrap mg-b-5"
            :key="item.id"
            :class="{
              active: item.id == status_id,
            }"
          >
            <a
              href="javascript:;"
              class="nav-link"
              @click="filterOrderByStatus(item.id, item.name)"
            >
              {{ item.name }}
              <span
                v-if="item.id == 4"
                v-show="m_status_num[item.id] > 0"
                class="
                  pd-r-8 pd-l-8
                  tx-8 tx-white
                  rounded-5
                  mg-l-10
                  bg-gray-300
                "
                >{{ m_status_num[item.id] }}</span
              >
              <span
                class="pd-r-8 pd-l-8 tx-8 tx-white rounded-5 mg-l-10 bg-teal"
                v-else-if="!(item.id == 3)"
                v-show="m_status_num[item.id] > 0"
                >{{ m_status_num[item.id] }}</span
              >
            </a>
          </div>
        </template>
      </nav>
    </div>
    <div>
      <h6
        class="
          tx-uppercase tx-12 tx-mont tx-spacing-1
          pd-x-10
          tx-white-7
          pd-b-10
        "
      >
        {{ $t("mall.条件筛选") }}
      </h6>
      <div class="pd-x-10">
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="keyType"
            @change="filterOrder"
          >
            <option value="">{{ $t("order.订单类型") }}</option>
            <option
              v-for="(type, index) in orderType"
              :key="index"
              :value="index"
            >
              {{ $t(type) }}
            </option>
          </select>
        </div>
        <div class="form-group mg-b-30">
          <select
            class="form-control form-control-dark select2 mg-b-10 select-mg"
            :data-placeholder="$t('distributor.采购单号')"
            v-model="codeType"
          >
            <option :value="1">
              {{ $t("distributor.采购单号") }}
            </option>
            <option :value="2">
              {{ $t("rm.生产单号") }}
            </option>
            <!-- <option :value="3">
              {{ $t("warehouse.SKU名称") }}
            </option>
            <option :value="4">
              {{ $t("order.SKU编号") }}
            </option> -->
          </select>
          <div class="search-sku">
            <input
              v-model="code"
              type="text"
              :placeholder="placeholder"
              class="form-control form-control-dark tx-13 mg-b-5"
            />
            <label
              class="ckbox mg-b-0 d-inline-block"
              data-toggle="tooltip"
              data-placement="right"
              data-trigger="hover"
              :data-original-title="
                $t('rm.勾选模糊匹配表示搜索采购单的SKU编号中包含当前填写的内容')
              "
              v-if="codeType == 4"
            >
              <input type="checkbox" v-model="isVague" />
              <span class="tx-white-8 tx-13">{{
                $t("order.SKU模糊搜索")
              }}</span>
            </label>
          </div>
        </div>
        <div class="mg-b-20 form-group">
          <div class="datepicker-group">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="timeCreatedFrom"
                data-id="datepicker-from"
                type="text"
                class="form-control-dark form-control fc-datepicker"
                :placeholder="$t('mall.起始日期')"
              />
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="timeCreatedTo"
                data-id="datepicker-to"
                type="text"
                class="form-control form-control-dark fc-datepicker"
                :placeholder="$t('mall.截止日期')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group mg-b-30">
      <button
        type="button"
        class="
          btn btn-primary search btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
        @click="filterOrder"
      >
        {{ $t("mall.筛 选") }}
      </button>
      <!-- todo3-生产订单 -->
      <button
        @click="batchSearch('manufactureOrder')"
        class="
          btn btn-primary batchSearch btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
      >
        {{ $t("distributor.批量搜索") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "status",
    "isHistoryData",
    "m_status_num",
    "m_status",
    "status_id",
    "key_type",
    "key_codeType",
    "key_code",
    "key_isVague",
    "key_timeCreatedFrom",
    "key_timeCreatedTo",
  ],
  data() {
    return {
      orderType: {
        1: "rm.成品生产单",
        2: "rm.半成品生产单",
        3: "rm.手动创建生产单",
      },
      statusId: "",
      keyType: "",
      codeType: 1,
      code: "",
      isVague: "",
      timeCreatedFrom: "",
      timeCreatedTo: "",
    };
  },
  computed: {
    placeholder() {
      if (this.codeType == 2) {
        return this.$t("rm.生产单号");
      } else if (this.codeType == 3) {
        return this.$t("warehouse.SKU名称");
      } else if (this.codeType == 4) {
        return this.$t("product.SKU编号");
      } else {
        return this.$t("distributor.采购单号");
      }
    },
  },
  watch: {
    status_id() {
      this.statusId = this.status_id;
    },
    key_type() {
      this.keyType = this.key_type;
    },
    key_codeType() {
      this.codeType = this.key_codeType;
    },
    key_code() {
      this.code = this.key_code;
    },
    key_isVague() {
      this.isVague = this.key_isVague;
    },
    key_timeCreatedFrom() {
      this.timeCreatedFrom = this.key_timeCreatedFrom;
    },
    key_timeCreatedTo() {
      this.timeCreatedTo = this.key_timeCreatedTo;
    },
  },
  mounted() {
    this.datepickerSelect();
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    // 格式化时间选择框
    datepickerSelect() {
      let vm = this;
      $("[data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.timeCreatedFrom = selectedDate;
          },
        });
      });
      $("[data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.timeCreatedTo = selectedDate;
          },
        });
      });
    },
    // 点击状态
    filterOrderByStatus(id, name) {
      if (this.$parent.filterProp.status == id) {
        this.$parent.filterProp.status = this.$parent.activeGroupName = "";
      } else {
        this.$parent.filterProp.status = id;
        this.$parent.activeGroupName = name;
      }

      this.filterOrder();
    },
    filterOrder() {
      this.$parent.filterProp.page = 1;
      this.$parent.filterProp.keyType = this.keyType;
      this.$parent.filterProp.codeType = this.codeType;
      this.$parent.filterProp.code = this.code;
      this.$parent.filterProp.isVague = this.isVague;
      this.$parent.filterProp.timeCreatedFrom = this.timeCreatedFrom;
      this.$parent.filterProp.timeCreatedTo = this.timeCreatedTo;

      this.$parent.getOrder(undefined, 'common');
    },
  },
};
</script>

<style>
</style>